import { Validator } from '../types/GenericFormTypes';
import { getFieldValue } from './getFieldValue';

export const makeRequiredValidator = (fieldId) => {
  return ((values, fields) => {
    const field = fields.find((f) => f.id === fieldId);

    const hidden =
      field &&
      (typeof field.visible === 'function'
        ? !field.visible(values)
        : field.visible === false);

    if (hidden) {
      return undefined;
    }

    const value = getFieldValue(values, fieldId)?.value;

    return [null, undefined, ''].includes(value as never) ||
      (Array.isArray(value) && (value as never[]).length === 0) ||
      (field.type === 'checkbox' && (value as boolean) === false)
      ? [
          {
            field: fieldId,
            message: 'Required',
            code: 'ERROR_REQUIRED',
            type: 'error'
          }
        ]
      : undefined;
  }) as Validator;
};
